export interface Bug {
    bugType?: string
    bugDetails?: string
    userWhoSubmitted?: string
    dateSubmitted?: Date
  }

  
export const BugTypes: Array<Bug> = [
  {
    bugType: "Connectivity Issue"
  },
  {
    bugType: "Unexpected Behavior"
  },
  {
    bugType: "Not Responsive"
  },
  {
    bugType: "Incorrect Data"
  },
  {
    bugType: "Other"
  }
]
  


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-bugreporting/bugs.ts